import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { WhatsNewPage } from "~/components/whats-new/whats-new-page";
import { whatsNewEntriesQueryOptions } from "~/lib/functions/whats-new";
import { featureModuleSchema } from "~/lib/shared/features/modules";

export const Route = createFileRoute("/_user/my-coaching/whats-new")({
  staticData: { title: "What's new" },
  // A stale or hand-edited module shows every update instead of an error page.
  validateSearch: z.object({
    module: featureModuleSchema.optional().catch(undefined),
  }),
  beforeLoad: ({ context }) => {
    if (context.isRevoked) {
      throw redirect({ to: "/my-coaching/clients/dashboard" });
    }
  },
  loaderDeps: ({ search }) => ({ module: search.module }),
  loader: async ({ context, deps }) => {
    await context.queryClient.ensureQueryData(
      whatsNewEntriesQueryOptions(deps.module),
    );
  },
  component: WhatsNewRoute,
});

function WhatsNewRoute(): React.JSX.Element {
  const { module } = Route.useSearch();
  const { data: entries } = useSuspenseQuery(
    whatsNewEntriesQueryOptions(module),
  );
  return <WhatsNewPage entries={entries} module={module} />;
}
